module.exports = __webpack_public_path__ + "media/images/badge-stripe-3d434d40.png";